import { Classification } from '../../model/attr/classification';
import { DictDataType } from '../../service/dict-data/dict-data-type.enum';
import { Injectable } from '@angular/core';
import { NecDictDataService } from '../../service/dict-data/dict-data.service';
import { Observable } from 'rxjs';


@Injectable()
export class NecClassificationService {

  constructor(private dictDataService: NecDictDataService) {
  }

  getClassifications(): Observable<Classification[]> {
    return this.dictDataService.getDictData(DictDataType.CLASSIFICATION);
  }
}
